import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "./Constants"; // your API base url without trailing slash

const DisplayUploads = (props) => {
  const [uploads, setUploads] = useState([]);
  const enrollId = props.id;
  useEffect(() => {
    const fetchUploads = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/upload-file`);  // Your route for index method
        setUploads(response.data);
        const filtereddata = response.data.filter(item => item.enrollment_id == enrollId && item.type == 'student-resource');
        setUploads(filtereddata);
      } catch (error) {
        console.error("Failed to fetch uploads", error);
      }
    };
    fetchUploads();
  }, []);

  const handleDownload = (filePath, title) => {
    // const url = `${API_BASE_URL.replace('/api', '')}/storage/${filePath}`;
        const url = `${API_BASE_URL.replace('/api', '')}/public/storage/${filePath}`;

  // Open the file URL in a new tab/window
  window.open(url, '_blank');
    // const url = `${API_BASE_URL.replace('/api', '')}/storage/${filePath}`;
    // const extension = filePath.split('.').pop();
    // const filename = `${title}.${extension}`;

    // const link = document.createElement('a');
    // link.href = url;
    // link.setAttribute('download', filename);
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
  };

  return (
    <div className="overflow-x-auto">
      {/* <h1 className="text-4xl font-bold mb-4 text-center text-indigo-800">{props.id}</h1> */}
      <table className="table table-zebra w-full">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Date Added</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {uploads.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center">No files uploaded yet.</td>
            </tr>
          ) : (
            uploads.map((item) => (
              <tr key={item.id}>
                <td className="font-bold">{item.title}</td>
                <td><span className="badge badge-outline">{item.file_path.split('.').pop().toUpperCase()}</span></td>
                <td>{new Date(item.created_at).toLocaleDateString()}</td>
                <td>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleDownload(item.file_path, item.title)}
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DisplayUploads;
